import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LayerService } from './../../../services/layer.service';
import { CommonTableService, TableColumn, TableRow } from './../../../services/common-table.service';
import { ToastrService } from 'ngx-toastr';

import { CommonDatagridComponent } from './../../common-datagrid/common-datagrid.component';
import { UserService, CustomerType } from 'app/services/user.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-user-admin-data',
	templateUrl: './user-admin-data.component.html',
	styleUrls: ['./user-admin-data.component.css']
})
export class UserAdminDataComponent implements OnInit, OnDestroy {

	@ViewChild('layerHistoriesTable', { static: false }) table: CommonDatagridComponent;
	@ViewChild('checkbox', { static: false }) checkbox: TemplateRef<any>;
	@ViewChild('headerTempl', { static: false }) headerTempl: TemplateRef<any>;
	@ViewChild('deleteStatus', { static: false }) deleteStatus: TemplateRef<any>;
	// @Input() columns: TableColumn[];
	// @Input() rows: TableRow[];


	public layers: any[];
	// delete button disable or not
	public isDelete: boolean;
	// purge button disable or not
	public isPurge: boolean;
	// rows of selected layer type
	public layerHistories: TableRow[] = [];
	public columns: TableColumn[];
	public deleteColumn = 'gly_deleted';
	public selectedColumn = 'selected';
	public buildTopoColumn = 'is_topo_built';
	public layerTypeId: number = null;
	// array of each input true/false value
	// public selects: { selected: boolean }[] = [];
	// selected rows' array
	public historySelected = [];

	// Is user a administrator
	public isAdmin: boolean;
	public customerType: CustomerType;

	// paging
	public pageSize: number;

	private selectedCustomerSub: Subscription;

	constructor(
		private commonService: CommonFunctionService,
		private layerService: LayerService,
		private tableService: CommonTableService,
		private userService: UserService,
		private toastr: ToastrService
	) {}
	setTable() {
		const columns = this.tableService.setColumnsFromRows(this.layerHistories);
		columns.forEach((c) => {
			if (c.prop === 'state') {
				c.cellClass = 'cell-align-C';
			} else if (c.prop === this.deleteColumn || c.prop === this.selectedColumn || c.prop === this.buildTopoColumn) {
				this.tableService.hideColumn(c);
			}
		});
		if (columns.length) {
			columns.unshift({
				isDisplay: true,
				name: ' ',
				prop: 'selected',
				type: 'text',
				width: 30,
				cellTemplate: this.checkbox,
				headerTemplate: this.headerTempl,
				cellClass: 'cell-align-C',
				info: { fixedCellClass: []}
			}, { isDisplay: true,
				name: 'DELETE STATE',
				prop: 'deleteStatus',
				type: 'text',
				width: 100,
				cellTemplate: this.deleteStatus,
				cellClass: 'cell-align-C',
				info: { fixedCellClass: []}
				}
			);
		}
		this.columns = columns;
	}
	async getLayerHistory() {
		this.commonService.setLoadingSpinner(true);
		try {
			this.cleanData();
			const rsp = await this.layerService.getRawLayers(this.userService.getCustomerIdByType(), this.layerTypeId, true);
			const rows = [];
			rsp.data.forEach((d) => {
				if (d.gly_id) {
					// this.layerHistories.push(d);
					d.selected = false;
					rows.push(d);
				}
			});
			this.layerHistories = rows;
			this.setTable();
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false);
	}
	// clean data
	cleanData() {
		this.historySelected = [];
		this.isDelete = null;
		this.isPurge = null;
	}
	// control single checkbox
	toggleCheckBox(event, row) {
		if (event.target.checked) {
			this.historySelected.push(row);
		} else {// uncheck the checkbox
			const index = this.historySelected.indexOf(row);
			this.historySelected.splice(index, 1);
		}
		this.setDeletable();
		this.setPurgeable();
	}
	selectAll(event) {
		if (event.target.checked) {
			this.layerHistories.forEach((row) => {
				row.selected = true;
			});
			// push all layerHistories in historySelected array
			this.historySelected = this.layerHistories;
		} else {
			this.layerHistories.forEach((row) => {
				row.selected = false;
			});
			this.historySelected = [];
		}
		this.setDeletable();
		this.setPurgeable();
	}
	// disable delete button
	setDeletable() {
		if (this.historySelected.some(e => e[this.deleteColumn] === false)) {
			this.isDelete = true;
		} else {
			this.isDelete = false;
		}
	}
	// disable purge button
	setPurgeable() {
		if (this.historySelected.some(e => e[this.deleteColumn] === true)) {
			this.isPurge = true;
		} else {
			this.isPurge = false;
		}
	}
	deleteLayers() {
		const promises = [];
		this.historySelected.forEach((d) => {
			if (d[this.deleteColumn] === false) {
				promises.push (
					new Promise ((resolve, reject) => {
						this.layerService.deleteLayer(d.gly_id, resolve, reject);
					})
				);
			}
		});
		Promise.all(promises).then((rsp) => {
			this.getLayerHistory();
			this.toastr.success('Successfully Deleted !');
		})
		.catch((e) => {
			this.toastr.error('Delete Failed');
		});
	}
	purgeLayer() {
		const promises = [];
		this.historySelected.forEach((d) => {
			if (d[this.deleteColumn] === true) {
				promises.push (
					new Promise ((resolve, reject) => {
						this.layerService.purgeLayer(d.gly_id, resolve, reject);
					})
				);
			}
		});
		Promise.all(promises).then((rsp) => {
			this.getLayerHistory();
			this.toastr.success('Successfully Purged !');
		})
		.catch((e) => {
			this.toastr.error('Purge Failed');
		});
	}
	async onChangeCustomer(e) {
		await this.getLayerHistory()
	}
	async ngOnInit() {
		this.pageSize = 50;

		this.isAdmin = this.userService.getUserInfo().isAdmin;
		this.customerType = this.userService.customerInfo.type;
		this.selectedCustomerSub = this.userService.selectedCustomer.subscribe((data) => {
			if (data) {
				let selectedCustomerId = data.id;
				this.onChangeCustomer({
					id: selectedCustomerId
				});
			}
		});
		try {
			const rsp = await this.layerService.getRawLayers(this.userService.getCustomerIdByType());
			this.layers = rsp.data;
			await this.getLayerHistory();
		} catch (err) {
			console.log(err);
		}
		// this.cleanData();
	}
	ngOnDestroy() {
		this.selectedCustomerSub.unsubscribe();
	}
}
